module.exports = __webpack_public_path__ + "img/kylian-mbappe.d01db448.png";